import {
  PROMO_CODES,
  PROMO_CODES_MODAL,
  PROMO_CODES_CREATED_NUMBER,
  PRODUCT_BATCHES_ROW_DATA,
  FETCH_PRODUCTS_REQUEST,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_FAILURE,
  ON_SELECT_PRODUCT_DATA,
  GENERAL_IMPORT_PRODUCT_DATA,
} from "../../constants/ActionTypes";

const initialSettings = {
  promoCodes: [],
  promoCodeModal: false,
  promoCodeCreatedNbr: [],
  getProductBatchesRowData: [],
  products: [],
  loading: false,
  error: null,
  searchSelectedProduct: [],
  generalImportProducts : []
};

const Products = (state = initialSettings, action) => {
  switch (action.type) {
    case PROMO_CODES:
      return {
        ...state,
        promoCodes: action.payload,
      };
    case PROMO_CODES_MODAL:
      return {
        ...state,
        promoCodeModal: action.payload,
      };
    case PROMO_CODES_CREATED_NUMBER:
      return {
        ...state,
        promoCodeCreatedNbr: action.payload,
      };
    case PRODUCT_BATCHES_ROW_DATA:
      return {
        ...state,
        getProductBatchesRowData: action.payload,
      };
    case FETCH_PRODUCTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_PRODUCTS_SUCCESS:
      return {
        ...state,
        loading: false,
        products: action.payload,
      };
    case FETCH_PRODUCTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ON_SELECT_PRODUCT_DATA:
      return {
        ...state,
        searchSelectedProduct: action.payload,
      };
      case GENERAL_IMPORT_PRODUCT_DATA:
        return {
          ...state,
          generalImportProducts :  action.payload
        }

    default:
      return state;
  }
};

export default Products;
